import styled from "styled-components";
import small_bg_dot from "@assets/Images/small_bg_dot.svg";

export const StyledOverTimeView = styled.div`
    padding-bottom: 4rem;
    background-color:${(p) => p.theme.colors.white02};

    .inputMonth {
        padding: 1rem;
        border-radius: 24px;
        color:${(p) => p.theme.colors.black01};
        background-color:${(p) => p.theme.colors.white02};
        border: 1px solid ${(p) => p.theme.colors.gray03};
        font-size: 1.5rem;
        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
        font-weight: 500;

        @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            margin-bottom:1rem;
            width:100%;
        }
    }
    .filters_label {
        font-size: 1.4rem;
    }
    .overtime {
        text-align: left;
        padding: 1rem 1.5rem;
        @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
            padding: 2rem 2rem;
        }
        @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            padding: 2rem 2rem;
        }
            margin-top:7rem;
            padding-bottom:8rem;
        &__form {
            display: flex;
            align-items: center;
            justify-content: space-between;
            @media (max-width: ${(p) => p.theme.breakPoints.breakBig}) {
                display: block;
            }
        }
        &__filter {
            padding: 2rem 0;
            display: flex;
            overflow-y: auto;
            column-gap: 0.5rem;
            margin-bottom: 2rem;
            @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
                width: 100%;
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 1rem;
                grid-template-columns: auto auto auto auto;
            }
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                max-width: 80rem;
                margin-bottom: 0;
            }
            .active {
                border: 1px solid ${(p) => p.theme.colors.secondary} !important;
                .title {
                    color: ${(p) => p.theme.colors.secondary}!important;
                }
            }
            &-item {
                display: flex;
                padding: 0.5rem 1rem;
                border-radius: 1.6rem;
                border: 1px solid ${(p) => p.theme.colors.darkBlack};
                justify-content: center;
                cursor: pointer;
                min-width: 12rem;
                .title {
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                    font-weight: 700;
                    padding-right: 1rem;
                    display: block;
                    display: -webkit-box;
                    max-width: 100%;
                    height: 20px;
                    line-height: 1.2;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
        &__search {
            // width:27rem;
            display:flex;
            align-items:center;
            gap:1rem;
            margin-top:0;

            @media (max-width: ${(p) => p.theme.breakPoints.breakBig}) {
              width:100%;
              display:block;
            }

            .wrapperSelect {
                width: 27rem;
                @media (max-width: ${(p) => p.theme.breakPoints.breakBig}) {
              width:100%;

            }
            }
        }
        &__title {
            display: flex;
            justify-content: flex-start;
            align-items:center;
            margin-bottom:2rem;
            // gap:2rem;
            &-btn {
                display: flex;
                @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                    flex-grow: 1;
                    justify-content: flex-end;
                }
                align-items: flex-end;
                .MuiButton-root {
                    font-size: 1.6rem;
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                    font-weight: 700;
                    background-color: ${(p) => p.theme.colors.darkBlack};
                    color: white;
                }
            }
        }
        &__title-left {
          width:18rem;
            @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
              width:40rem;
            }
        }
        &__title-right {
          margin-left: auto; // pushes this button to the far right
        }            
        &__selectMonth {
          display:flex;
          justify-content:space-between;
          align-items:center;

         @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            display:block;
            justify-content:none;
            margin-bottom:1rem;
        }

        }
        &__listItem {
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                // width: 90%;
            }
            .form {
                &__checkbox {
                    padding: 1.5rem 0;
                    .MuiFormGroup-root {
                        display: flex;
                        flex-direction: row;
                    }
                    .MuiFormControlLabel-label {
                        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                        font-weight: 700;
                    }
                    .MuiTypography-root {
                        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                        font-weight: 700;
                        font-size: 1.2rem;
                        color: #d5d5d5;
                    }
                    .MuiSvgIcon-root {
                        width: 1.5em;
                        height: 1.5em;
                    }
                    .active {
                        .MuiTypography-root {
                            color: ${(p) => p.theme.colors.darkBlack} !important;
                        }
                    }
                }
                &__searchInput {
                    padding: 2rem 0;
                    @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                        width: 40%;
                    }
                }
            }
            .wrapperLoading {
                padding-top: 4rem;
            }
        }
    }
`;

export const StyledOTItem = styled.div`
    .item {
        width: 100%;
        padding: 1.6rem;
        margin: 1.5rem 0;
        border-bottom: 1px solid #d6d6d6;
        &__top {
            display: flex;
            justify-content: space-between;
        }
        &__userInfo {
            display: flex;
            flex: 2;
            &-title {
                padding-left: 1rem;
                .name {
                    font-size: 1.6rem;
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                    font-weight: 700;
                    display: block;
                    display: -webkit-box;
                    line-height: 1.2;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
        &__status {
            &-checked {
                padding: 0.4rem 1rem;
                background-color: #d6fddc;
                display: flex;
                .text {
                    padding-right: 0.5rem;
                    color: #0aba3b;
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                    font-weight: 700;
                }
                .icon {
                    display: block;
                    padding-top: 0.1rem;
                }
            }
            &-unChecked {
                padding: 0.4rem 1rem;
                background-color: #fdd6d6;
                display: flex;
                .text {
                    padding-right: 0.5rem;
                    color: #ba0a0a;
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                    font-weight: 700;
                }
                .icon {
                    display: block;
                    padding-top: 0.1rem;
                }
            }
            &-pending {
                padding: 0.4rem 1rem;
                background-color: #e9e9e9;
            }
        }
        &__title {
            flex: 2;
            .content {
                display: block;
                display: -webkit-box;
                max-width: 100%;
                height: 20px;
                line-height: 1.2;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        &__date {
            display: flex;
            justify-content: space-between;
            padding-top: 2.5rem;
            flex: 7;
            &-start,
            &-end,
            &-hour {
                flex: 2;
            }
            .title {
                font-size: 1.2rem;
                color: #d4d4d4;
                font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                font-weight: 700;
            }
        }
        .desktop {
            display: none;
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                display: flex;
                width: 60%;
                padding-top: 0;
            }
        }
        .mobile {
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                display: none;
            }
        }
    }
`;
export const StyledDetailView = styled.div`
    // padding-bottom: 4rem;

    .detail {
        min-height: 100vh;
        // background-image: url(${small_bg_dot});
        // background-repeat: no-repeat;
        background-color: ${(p) => p.theme.colors.white02};
        text-align: left;
        padding: 1rem 1.5rem;
        @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
            padding: 2rem 2rem;
        }
        @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            padding: 2rem 2rem;
        }

        &__top {
            display: flex;
            flex-direction: column;
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                flex-direction: row;
            }
            &-status {
                @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                    padding-top: 1rem;
                    padding-left: 2rem;
                }
            }
            &-title {
                font-size: 3.2rem;
                font-family: ${(p) => p.theme.fontFamily.MochiyPopOne_Regular};
                color: ${(p) => p.theme.colors.black01};
            }
            &-icon {
                width: 5rem;
                margin-right: 4rem;
                div {
                    width: 100%;
                    button {
                        width: 100%;
                        display: flex;
                        justify-content: end;
                    }
                }
                .MuiIconButton-root {
                    padding-left: 0;
                }
            }
            &-checked {
                padding: 0.4rem 1rem;
                background-color: #d6fddc;
                display: flex;
                align-items:center;
                width: 6rem;
                .text {
                    padding-right: 0.5rem;
                    color: #0aba3b;
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                    font-weight: 700;
                }
                .icon {
                    display: block;
                    padding-top: 0.1rem;
                }
            }
            &-unChecked {
                padding: 0.4rem 1rem;
                background-color: #fdd6d6;
                display: flex;
                align-items:center;
                width: 6rem;
                .text {
                    padding-right: 0.5rem;
                    color: #ba0a0a;
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                    font-weight: 700;
                }
                .icon {
                    display: block;
                    padding-top: 0.1rem;
                }
            }
            &-pending {
                padding: 0.4rem 1rem;
                background-color: #e9e9e9;
                width: 6rem;
            }
        }
        .wrapper {
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                width: 100%;
                // display: flex;
                // justify-content: center;
            }
        }

        &__content {
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                // width: 45rem;
            }
            &-info,
            &-time {
                margin: 3rem 0;
                // padding: 1.5rem 1.6rem;
                background-color: ${(p) => p.theme.colors.white00};
                border-radius: 6px;
                box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
            }
            &-main {
                    padding:1.5rem;
                }
            .user__timmer {
                display: flex;
                justify-content: space-between;
            }
            .user {
                display: flex;
                // padding: 1.5rem 0;
                &__name {
                    // width: 70%;
                    display:flex;
                    margin-bottom:2rem;
                }
                &__avatar {
                    display: flex;
                    padding-top: 1rem;
                }
                &__profile {
                    padding-right: 1rem;
                }
                &__title {
                    margin-right:1rem;
                }
                &__text-main {
                    display: flex;
                    align-items: center;
                    // font-size: 1.6rem;
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
                    font-weight: 500;
                    // padding-top: 1rem;
                }
                &__timesheet {
                    /* margin-bottom: 1rem; */
                    white-space: nowrap;
                }
                &-right {
                    margin-top: 2rem;
                    &timmer {
                    }
                }
                &-content {
                    display: flex;
                    align-items: center;
                    justify-content: space-start;
                    &__left {
                        width: 70%;
                    }
                }
                &__contents {
                    padding:1rem;
                    display:flex;
                    justify-content:space-between;
                    align-items:center;
                    border-bottom:1px solid ${(p) => p.theme.colors.lightgray09};

                }
                &__contents-last {
                    padding:1rem;
                    display:flex;
                    justify-content:space-between;
                    align-items:center;


                }

            }
            .date {
                display: flex;
                justify-content: space-start;
                margin-bottom: 1rem;
                .content {
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
                    font-weight: 500;
                    font-size: 1.6rem;
                }
                &__left {
                    width: 70%;
                }
                &__right {
                    /* margin-left: 9rem; */
                }
            }
            .des {
                padding-top: 1rem;
                &__title {
                    padding: 1rem 0;
                }
                &__content {
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
                    font-weight: 500;
                    font-size: 1.6rem;
                }
            }
            &-top__title {
                padding:1.5rem;
                background-color:${(p) => p.theme.colors.lightgray09};
                color:${(p) => p.theme.colors.black01};
                text-align: left;
                font-size: 2rem;
                line-height: 2.25rem;
                font-weight: 600;
                border-top-right-radius:6px;
                border-top-left-radius:6px;
                span {
                    margin: 0 1rem;
                    @media (max-width: 375px) {
                        font-size: 16px;
                    }
                }
                span:first-child {
                    margin-left: 0;
                }
                span:last-child {
                    margin-right: 0;
                }
            }
        }
    }
`;
export const StyledNewOT = styled.div`
    // padding-bottom: 4rem;
    .newOT {
        min-height: 100vh;
        // background-image: url(${small_bg_dot});
        // background-repeat: no-repeat;
        background-color: ${(p) => p.theme.colors.white02};
        text-align: left;
        padding: 1rem 1rem;
        @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
            padding: 2rem 2rem;
        }
        @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            padding: 2rem 2rem;
        }
            margin-top:7rem;
            padding-bottom:12rem;
        .MuiFormGroup-root {
            display: flex;
            flex-direction: row;
        }
        .MuiFormControlLabel-root {
            margin-right: 16px !important;
            margin-left: 0 !important;
            height: 4.5rem;
        }
        .datePicker {
            .MuiOutlinedInput-input {
                padding: 8.5px 14px !important;
                height: 1.4375em;
            }
        }
        &__top {
            display: flex;
            flex-direction: column;
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                flex-direction: row;
            }
            &-status {
                @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                    padding-top: 1rem;
                    padding-left: 2rem;
                }
            }
            &-title {
                font-size: 3.2rem;
                color:${(p) => p.theme.colors.black01};
                font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                font-weight: 700;
            }
            &-icon {
                width: 5rem;
                margin-right: 4rem;
                div {
                    width: 100%;
                    button {
                        width: 100%;
                        display: flex;
                        justify-content: end;
                    }
                }
                .MuiIconButton-root {
                    padding-left: 0;
                }
            }
        }
        .wrapperContent {
            width: 100%;
            // display: flex;
            // justify-content: center;
        }
        .content {

            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                // width: 80rem;
            }
        }
        .approval {
            margin-top: 2rem;
            padding: 1rem 1rem;
            border-radius: 6px;
            background-color:${(p) => p.theme.colors.white00};
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                padding: 2rem 2rem;
            }
        }
        .userContent {
          padding:1rem;

        }
        .topContent {
          width:70%;
          @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                width:100%;
            }

        }
        .selectButton {
          padding:2rem 0;
          display:flex;
          justify-content:flex-start;
          gap:1rem;
          border-bottom:1px solid ${(p) => p.theme.colors.lightgray09};

          @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                justify-content:space-around;
            }


        }
        &__user {
            margin-top: 2rem;
            // padding: 2.5rem 1.5rem;
            border-radius: 6px;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
            background-color: ${(p) => p.theme.colors.white00};
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                // padding: 5rem 8rem;
            }
            .id {
                font-size: 1.6rem;
                color: ${(p) => p.theme.colors.black01};
            }
            .userInfo {

                border-top-right-radius:6px;
                border-top-left-radius:6px;
                background-color: ${(p) => p.theme.colors.lightgray09};

                display: flex;
                align-items:center;

                // margin-bottom: 1rem;
                width: 100%;
                // justify-content: space-between;
                &__name {
                    padding:1rem;
                    color: ${(p) => p.theme.colors.black01};
                    /* width: 70%; */
                    // min-width: 32 rem;
                    @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                        // min-width: 32 rem;
                    }
                }
                &__typeTempo {
                    font-size: 2rem;
                    font-weight: 900;
                    color: black;
                    height: fit-content;
                    padding: 10px;
                    border: 2px solid orange;
                    border-radius: 1.6rem;
                    :hover {
                        background-color: orange;
                        color: black;
                        cursor: pointer;
                    }
                }
                &__typeOfficial {
                    font-size: 2.5rem;
                    font-weight: 900;
                    color: black;
                }
                .title {
                    color: #656565;
                }
                .wrapperAvatar {
                    display: flex;
                    padding-top: 1rem;
                }
                .id {
                    padding-top: 2rem;
                }
                .name {
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
                    font-weight: 500;
                    font-size: 1.6rem;
                    display: flex;
                    align-items: center;
                    padding-top: 1rem;
                    padding-left: 1rem;
                    display: block;
                    display: -webkit-box;
                    max-width: 100%;
                    /* height: 40px; */
                    line-height: 1.2;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            .label-type-overtime {
                label {
                    padding-right: 1rem;
                    padding-left: 1rem;
                    border-radius: 1.6rem;
                    display: flex;
                    justify-content: center;
                    &.active {
                        background-color: white;
                    }
                    background-color: orange;
                }
            }
            .user__title {
              padding:1.5rem 0;
              border-bottom:1px solid ${(p) => p.theme.colors.lightgray09};

            }
            .user__department {
                padding: 1.2rem 0;
                @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                    margin-top: 2rem;
                }
            }
        }
        .label {
            padding-bottom: 0.3rem;
            color:${(p) => p.theme.colors.black01};
        }
        .input {
            // padding-top: 1rem;
        }
        .dateTime {
            display: flex !important;
            .MuiOutlinedInput-input {
                padding: 8.5px 14px !important;
                height: 1.4375em;
            }
            &__date {
            }
            &__time {
                margin-left: 20px;
            }
        }
        &__time {
            // margin-top: 2rem;
            padding: 1rem 1rem;
            // border-radius: 1.6rem;
            // background-color: white;
            width:70%;
            @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                width:100%;
            }
        }
        &__btn {
            padding: 1rem 1rem;
            display: flex;
            justify-content: flex-end;
            align-items:center;
            @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                justify-content: center;
              }
            .wrapperBtn {
                width: 100%;
                @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                    width: 40rem;
                }
            }
            .delete {
                /* margin: 2rem 0 !important; */
                width: 100%;
                .MuiButton-root {
                    background-color: ${(p) => p.theme.colors.secondary};
                }
                @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                    width: 40rem;
                }
            }
        }
        .note {
            padding-bottom: 1rem;
            &__subTitle {
                padding-left: 0.5rem;
                color: #656565;
            }
        }
    }
`;
export const StyledOTApprovalProcess = styled.div`
    padding: 2rem 0;
    .process {
        margin-bottom: 1rem;
        &__divider {
            min-height: 5rem;
            width: 1.5px;
            background-color:${(p) => p.theme.colors.lightgray09};
            margin-left: 0.5rem;
        }
        &__top,
        &__bottom {
            display: flex;
        }
        &__bottom {
            padding: 0;
        }
        &__circle {
            width: 1.2rem;
            height: 1.2rem;
            border-radius: 100%;
            background-color: blue;
            margin-right: 2rem;
        }
        &__title {
            font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
            font-weight: 500;
            font-size: 1.4rem;
            color: #8e8e8e;
        }
        &__content {
            width: 80%;
        }
        &__container {
            display:flex;
            align-items:center;
            gap:1rem;
            }
        .note {
            color: #656565;
        }
        &__person {
            gap:1rem;
            display: flex;
            align-items:center;
            // padding-top: 0.5rem;
            .MuiAvatar-root {
                width: 3.5rem;
                height: 3.5rem;
            }
            &-name {
                display: flex;
                align-items: center;
                font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                font-weight: 700;
            }
        }
        &__date {
            display: flex;
            // flex-direction: column;
            // justify-content: center;
            align-items: center;
            &-time {
                display: flex;
                text-align: center;
            }
        }
        &__status {
            &-checked {
                padding: 0.4rem 1rem;
                background-color: ${(p) => p.theme.colors.green07};
                display: flex;
                align-items:center;
                border-radius:50px;
                .text {
                    padding-right: 0.5rem;
                    color: ${(p) => p.theme.colors.white00};
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                    font-weight: 700;
                }
                .icon {
                    display: block;
                    padding-top: 0.1rem;
                }
            }
            &-unChecked {
                padding: 0.4rem 1rem;
                background-color:${(p) => p.theme.colors.red05};
                display: flex;
                align-items:center;
                border-radius:50px;
                .text {
                    padding-right: 0.5rem;
                    color: ${(p) => p.theme.colors.white00};
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                    font-weight: 700;
                }
                .icon {
                    display: block;
                    padding-top: 0.1rem;
                }
            }
            &-pending {
                padding: 0.4rem 1rem;
                background-color: #e9e9e9;
                border-radius:50px;
            }
        }
    }
    .processForm {
        margin: 2rem;
        .MuiRadio-root {
            .MuiSvgIcon-root {
                width: 1.5em;
                height: 1.5em;
            }
        }
        .title {
            font-size: 1.4rem;
            font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
            font-weight: 500;
            padding-right: 0.5rem;
        }
        .Mui-checked {
            color: ${(p) => p.theme.colors.primary};
        }
    }
`;
export const StyledOverTimeCalendar = styled.div`
min-height: 80rem;
background-color: ${(p) => p.theme.colors.white00};
box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
color:${(p) => p.theme.colors.black01};
.rbc-header {
background-color: ${(p) => p.theme.colors.lightgray09};
}
    // min-height: 80rem;
    .rbc-calendar {
       min-height: 80rem;
    }

    .rbc-day-bg {
    position:relative;
    }

    .rbc-day-bg.holiday-bg {
      background-color:${(p) => p.theme.colors.red05} !important;
    }

    .rbc-agenda-date-cell.holiday-bg {
      color: ${(p) => p.theme.colors.red05} !important;
      font-weight:bold;
    }

    .rbc-event,
    .rbc-day-slot .rbc-background-event {
        background-color: transparent;
    }
    .rbc-month-row {
        overflow: visible !important;
    }
    .rbc-toolbar {
        display: none;
    }
    .rbc-row:nth-of-type(2) {
      flex-grow: 1;
    }
    .rbc-event {
        cursor: pointer;
        position: relative;
        // height: 110px;
        height: 100%;
        overflow-y: auto;
        z-index: 10;
    }

    .rbc-event:hover {
        scrollbar-width: 3px;
        overflow-y: auto;
    }
    .rbc-event::-webkit-scrollbar {
        width: 4px;
    }

    .rbc-event::-webkit-scrollbar-track {
        background-color: #f1f1f1;
    }

    .rbc-event::-webkit-scrollbar-thumb {
        background-color: #999;
        border-radius: 4px;
    }

    .rbc-event::-webkit-scrollbar-thumb:hover {
        background-color: #888;
    }
    .rbc-event:focus {
        outline: none;
    }
    .rbc-row-content {
        position: relative;
        user-select: auto;
        /* -webkit-user-select: none; */
        z-index: 10;
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    .rbc-selected-cell {
        background: transparent;
    }
    .rbc-today {
        background-color: transparent;
    }
    .rbc-agenda-time-cell {
        display: none !important;
    }
    .rbc-agenda-event-cell {
        border-left:none !important;
    }
    .rbc-agenda-view table thead tr {
        display: none !important;
    }
`;

export const StyledOverTimeEventContent = styled.div`
    .groupUser {
        .mine {
            .content {
                background-color: #b0eefc !important;
                padding: 0.4rem !important ;
            }
            border-radius: 1rem !important;
        }
        .user {
            display: flex;
            flex-direction: column;
            color: ${(p) => p.theme.colors.black01};
            .more {
                &__dot {
                    padding: 0.2rem 0.8rem;
                    text-align: center;
                    @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                        display: none;
                    }
                }
            }
            .wrapperAvatar {
                padding: 0.5rem;
                display: flex;
                z-index: 10;
                @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                    padding: 0.5rem 1.5rem;
                }
                @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                    padding: 0.5rem;
                    border-radius: 1rem;
                    padding: 0.5rem 0.8rem;
                }
            }
            .content {
                display: flex;
                background-color: #e7e7e7;
                padding: 0;
                border-radius: 1.6rem;
                align-items: center;

                @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                    padding: 0.5rem 1rem;
                }
            }
            .name {
                font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
                font-weight: 500;
                font-size: 1.4rem;
                text-align: center;
                // display: none;
                @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                    display: block;
                    display: -webkit-box;
                    max-width: 9rem;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding-left: 1rem;
                }
            }
            .MuiAvatar-root {
                width: 2.5rem;
                height: 2.5rem;
            }
        }
    }
    .mobile {
        &__dot {
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                display: none;
            }
        }
    }
    .more__text {
        display: none;
        font-size: 1.3rem;
        padding-left: 2rem;
        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
        font-weight: 500;
        color: #656565;
        @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            display: block;
        }
    }
`;

export const StyledWrapCalendarComponent = styled.div`
    margin-top: 15px;
    .rbc-month-view {
        z-index: 0;
    }
    .csvExportDiv {
        // border-top: 1px solid ${(p) => p.theme.colors.lightgray09};
        padding: 2rem;
        gap: 2rem;
        margin-top:1rem;
        width: 100%;
        text-align: left;
        @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            padding: 0;
            text-align: center;
        }
    }
    .csvExportTitle {
        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
        font-weight: 700;
        font-size: 1.6rem;
        color:${(p) => p.theme.colors.black01};
    }

    .dateContainer {
      display: flex;
      flex-direction: column;
      gap: 0.8rem;
      margin-bottom:1rem;
      margin-top:1rem;
    }

    .dateSubContainer {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            justify-content: space-between;
        }
    }

    .ot {
        padding: 1rem 1.5rem;
        min-height: 80vh;
        @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
            padding: 2rem 8rem;
        }
        @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            padding: 2rem 11rem;
        }
        &__datePicker {
            display: flex;
            align-items: center;
            gap: 1rem;
             @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            width:100%;
            display: block;
            }
            .label {
                display: flex;
                align-items: center;
                width:14rem;
            }
            .wrapperDatePicker {
                width: 18rem;
            }
            .inputDate {
                flex:1;
                width100%;
                padding: 1rem;
                border-radius: 24px;
                border: 1px solid #888;
                font-size: 1.5rem;
                color:${(p) => p.theme.colors.black01};
                background-color:${(p) => p.theme.colors.white02};
                font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
                font-weight: 500;
            }
        }
        &__calendar {
            padding-top: 2rem;
        }
    }
    .inputMonth {
        padding: 1rem;
        border-radius: 1rem;
        border: 1px solid #888;
        font-size: 1.5rem;
        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
        font-weight: 500;
    }
    .dateContainer {
        @media (min-width: 768px) {
          display: flex;
          flex-direction: row;
          justify-content: center;
        }
        @media (min-width: 100px) and (max-width: 768px) {
        }
`;

export const StyledOverTimeContentModal = styled.div`
    padding: 2.5rem 4rem;

    .toggle {
        &__top {
            &-collapse {
                display: flex;
            }
            .collapse-title {
                font-size: 1.4rem;
            }
            padding-bottom: 2.4rem;
            &-date {
                font-size: 3.6rem;
                font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                font-weight: 700;
            }
            &-icon {
                width: 2.5rem;
                height: 2.5rem;
                cursor: pointer;
            }
        }
        &__user {
            margin-top: 3rem;
            margin-bottom: 3rem;
            cursor: pointer;
            &-item {
                display: flex;
                padding: 0.6rem 1.2rem;
                background-color: #b0eefc;
                border-radius: 24px;
                margin-bottom: 2rem;
            }
            &-name {
                padding-top: 1rem;
                padding-left: 1rem;
                font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                font-weight: 700;
                font-size: 1.4rem;
                display: flex;
                align-items: center;
                height: 3.5rem;
                display: -webkit-box;
                max-width: 100%;
                line-height: 1.2;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .wrapperList {
            max-height: 70vh;
            overflow-y: auto;
        }
        &__groupUser {
            padding-top: 2rem;
            padding-bottom: 2rem;
            &-title {
                font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                font-weight: 700;
                font-size: 1.6rem;
            }
            &-list {
                padding-left: 2rem;

                .item {
                    padding: 1rem 0;
                    display: flex;
                    cursor: pointer;
                    &__title {
                        margin-top: 1rem;
                        padding-left: 1rem;
                        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                        font-weight: 700;
                        font-size: 1.4rem;
                        display: flex;
                        align-items: center;
                        height: 3.5rem;
                        display: -webkit-box;
                        max-width: 100%;
                        line-height: 1.2;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }
`;
export const StyledOverTimePopoverList = styled.div`
    display: flex;
    flex-direction: column;

    .contain {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .wrapItem {
            border-radius:6px;
            padding: 2rem;
            cursor: pointer;
            transition: 250ms;
            display: flex;
            justify-content: flex-end;
            &:hover {
                background-color: #43cdec;
            }
        }

        .wrapItemTempo {
            padding: 2rem 0rem;
            cursor: pointer;
            transition: 250ms;
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }
        .item {
            font-size: 1.4rem;
            padding: 0 !important;
            &__status {
                &-checked {
                    border-radius:6px;
                    padding: 0.4rem 1rem;
                    background-color: #d6fddc;
                    display: flex;
                    .text {
                        padding-right: 0.5rem;
                        color: #0aba3b;
                        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                        font-weight: 700;
                    }
                    .icon {
                        display: block;
                        padding-top: 0.1rem;
                    }
                }
                &-unChecked {
                    border-radius:6px;
                    padding: 0.4rem 1rem;
                    background-color: #fdd6d6;
                    display: flex;
                    .text {
                        padding-right: 0.5rem;
                        color: #ba0a0a;
                        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                        font-weight: 700;
                    }
                    .icon {
                        display: block;
                        padding-top: 0.1rem;
                    }
                }
                &-pending {
                    border-radius:6px;
                    padding: 0.4rem 1rem;
                    background-color: #e9e9e9;
                }
                &-official {
                    border-radius:6px;
                    padding: 0.4rem 1rem;
                    background-color: red;
                    color: #fff;
                    &:hover {
                        background-color: #fdd7d7;
                    }
                }
            }
        }
    }
    .title {
        font-size: 1.4rem;
        padding-right: 2rem;
        margin-bottom: 1rem;
        display: flex;
        justify-content: flex-end;
    }
`;

export const TextTile = styled.p`
    font-size: 16px;
    font-weight: 700;
`;
